export var UPDATE_NOTIFICATION = "Nueva notificación";
var NotificationUpdate = /** @class */ (function () {
    function NotificationUpdate(payload) {
        this.payload = payload;
        this.type = UPDATE_NOTIFICATION;
    }
    return NotificationUpdate;
}());
export { NotificationUpdate };
